import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  createQueryParams,
  IPeril,
  IPerilQueryParams,
  IPerilRequest,
} from '@inshuwa-client/models';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';

@Injectable({
  providedIn: 'root',
})
export class PerilService {
  constructor(private httpClient: HttpClient) {}
  getPerils(query: Partial<IPerilQueryParams>): Observable<IPeril[]> {
    return this.httpClient.get<IPeril[]>(`${baseUrl()}/perils`, {
      params: createQueryParams(query),
    });
  }
  addPeril(payload: IPerilRequest) {
    return this.httpClient.post<IPeril>(`${baseUrl()}/perils`, payload);
  }
}